import { defaultEnvironmentConfigs, IEnvironment } from './environment.defaults';

export const environment: IEnvironment = {
  ...defaultEnvironmentConfigs,
  appInsights: {
    cloudRole: 'digital-boards-angular',
    instrumentationKey: '004838ad-5c0d-4b32-9dba-05cb5976120a',
  },
  env: 'PROD',
  ssoEnv: 'PROD',
};
